import PaymentsIcon from '@mui/icons-material/Payments';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

import {
  EditionPriceFields,
  formatEditionPriceAmountLabel,
} from 'src/helpers/editionPriceTier';

interface Props {
  checkinsByPrice: Record<string, number>;
  totalPrice: number;
  editionPrices: EditionPriceFields;
  disableGutters?: boolean;
  emphasizeTotal?: boolean;
}

const EditionTotalsSummary = ({
  checkinsByPrice,
  totalPrice,
  editionPrices,
  disableGutters = false,
  emphasizeTotal = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <List sx={{ width: '100%', pt: disableGutters ? 0 : 1, pb: 0, flexGrow: 1 }}>
      {Object.entries(checkinsByPrice).map(([price, count]) => {
        const amount = Number(price);
        const tierLabel = formatEditionPriceAmountLabel(amount, editionPrices, t);

        return (
          <ListItem key={price} disableGutters={disableGutters}>
            <ListItemText
              primary={t('checkins.checkinsCountWithTier', {
                count,
                tier: tierLabel,
                interpolation: { escapeValue: false },
              })}
              secondary={t('base.currencyValue', { count: amount })}
            />
          </ListItem>
        );
      })}
      <ListItem disableGutters={disableGutters}>
        <ListItemIcon sx={disableGutters ? { minWidth: 36 } : undefined}>
          <PaymentsIcon color={disableGutters ? 'action' : undefined} />
        </ListItemIcon>
        <ListItemText
          primary={t('checkins.total')}
          secondary={t('base.currencyValue', { count: totalPrice })}
          sx={
            emphasizeTotal
              ? { '& .MuiListItemText-primary': { fontWeight: 600 } }
              : undefined
          }
        />
      </ListItem>
    </List>
  );
};

export default EditionTotalsSummary;
